import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';

/**
 * متن طولانی: حداکثر N خط + «دیدن بیشتر»
 * ارتفاع با inline style و !important اعمال می‌شود تا CSS سراسری پنل نتواند آن را بشکند.
 */
const ExpandableText = ({
  text,
  maxLines = 3,
  className = '',
  textClassName = '',
  moreLabel = 'دیدن بیشتر',
  lessLabel = 'کمتر',
  /** ارتفاع تقریبی هر خط به پیکسل (text-sm ≈ 14px × 1.6) */
  lineHeightPx = 22,
}) => {
  const [expanded, setExpanded] = useState(false);
  const [needsToggle, setNeedsToggle] = useState(false);
  const textRef = useRef(null);
  const maxHeightPx = maxLines * lineHeightPx;

  useEffect(() => {
    setExpanded(false);
  }, [text]);

  useLayoutEffect(() => {
    const el = textRef.current;
    if (!el || !text) {
      setNeedsToggle(false);
      return;
    }

    if (!expanded) {
      el.style.setProperty('max-height', `${maxHeightPx}px`, 'important');
      el.style.setProperty('overflow', 'hidden', 'important');
    } else {
      el.style.removeProperty('max-height');
      el.style.setProperty('overflow', 'visible', 'important');
    }

    // تشخیص نیاز به دکمه: ارتفاع کامل متن > سقف ۳ خط
    const fullHeight = el.scrollHeight;
    setNeedsToggle(fullHeight > maxHeightPx + 2);
  }, [text, maxHeightPx, expanded]);

  if (!text) return null;

  return (
    <div className={`expandable-text ${className}`}>
      <div
        ref={textRef}
        className={`expandable-text__body custom-font ${textClassName}`}
        style={{
          margin: 0,
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          overflowWrap: 'anywhere',
          lineHeight: `${lineHeightPx}px`,
        }}
      >
        {text}
      </div>
      {needsToggle ? (
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setExpanded((v) => !v);
          }}
          className="expandable-text__toggle mt-1.5 p-0 border-0 bg-transparent text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300 text-xs font-medium cursor-pointer custom-font"
        >
          {expanded ? lessLabel : moreLabel}
        </button>
      ) : null}
    </div>
  );
};

export default ExpandableText;
